import Vue from "vue"
import VueCompositionApi, {reactive, watch} from "@vue/composition-api"
import {WidgetParameters, WParamTpl, WSizing} from "@/components/widgets/WidgetFather"
import {deepMerge, throttle} from "@/utils"

Vue.use(VueCompositionApi) // workaround for plub-in composition API, should be removed in Vue 3

const apiThrottle = 1000 // min time between API calls (ms)

export const globalParams = reactive({
  locationId: {
    ...WParamTpl.locationId(),
    _override: false,
    value: "10",
  },
} as WidgetParameters) // Some defaults for global params

function loadGlobalParams() {
  if (process.env.NODE_ENV === "test") {
    return
  }
  const gpStr = sessionStorage.getItem("globalParams")
  if (gpStr && gpStr.length) {
    try {
      Object.assign(globalParams, JSON.parse(gpStr))
    } catch {
      // Do or do not! There is no try!
    }
  }
}

loadGlobalParams()

export function saveGlobalParams() {
  sessionStorage.setItem("globalParams", JSON.stringify(globalParams))
}

export function hasGlobalOverride(pName: string) {
  if (pName && globalParams[pName] !== undefined) {
    return globalParams[pName]._override
  } else {
    return false
  }
}

function overrideGlobalParams(p: WidgetParameters) {
  const out = deepMerge({}, p)
  Object.keys(p || {}).forEach((key: string) => {
    if (globalParams[key] && globalParams[key]._override && globalParams[key].value !== p[key].value) {
      out[key] = deepMerge({}, globalParams[key])
      // console.log("overrode", key, p[key].value, ">>>", globalParams[key].value)
    }
  })
  return out
}

export function setupConfigWatcher(config: any, chartConfig: any, chartDataConfig: any, extraCallback: any = null) {
  watch(() => [config, globalParams], () => {
    if (config) {
      chartDataConfig.theme = config.theme
      chartConfig.type = config.cType || 'pie3d'
      chartConfig.width = WSizing.width(config.w)
      chartConfig.height = WSizing.height(config.h)
      config.fusionChartParams
      && Object.keys(config.fusionChartParams).forEach((key: any) => {
        if (config.fusionChartParams[key].value !== undefined) {
          const optKey: string = config.fusionChartParams[key].value || ""
          if (typeof (config.fusionChartParams[key]._opts.options.get) === "function") {
            const newChartDataConfig = config.fusionChartParams[key]._opts.options.get(optKey)
            newChartDataConfig && deepMerge(chartDataConfig, newChartDataConfig)
          }
        }
      })
      if (extraCallback) {
        extraCallback({...config, params: overrideGlobalParams(config.params)}, chartConfig, chartDataConfig)
      }
    }
  }, {deep: true})
}

export function setupParamWatcher(fetcherFn: Function, chartDS: any, chartDataConfig: any, config: any) {
  watch(() => [config, globalParams], () => {
    fetcherFn(chartDS, chartDataConfig, overrideGlobalParams(config.params))
  }, {deep: true})
}

export function fusionDataFetcher(fetcherFn: (params: any) => any) {
  return throttle((chartDS: any, chartDataConfig: any, params: any) => {
    (async () => Object.assign(chartDS, {chart: chartDataConfig, ...await fetcherFn(params)}))()
  }, apiThrottle)
}

export function enumTitleLookup(params: any): string {
  const op = params.opts && params.opts.options
  if (!op) {
    return ""
  }
  for (const k in op) {
    if (params.value === op[k].value) {
      return op[k].title
    }
  }
  console.error("enum title not found:", params.value)
  return params.value + "???"
}
